import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { ActionItemsTemplateDetails, ActionItemsTemplateDetailsStore } from '@core/models/action-item-templates/action-item-template-details.model';

@Injectable({
  providedIn: 'root'
})
export class ActionItemsTemplateDetailsStoreService {

  private readonly _initialStoreData: ActionItemsTemplateDetailsStore = {
    templateDetails: null,
    sysText: null
  };

  private templateDetailsStore: BehaviorSubject<ActionItemsTemplateDetailsStore>;  
  private store$: Observable<ActionItemsTemplateDetailsStore>;

  private readonly templateNames = {
    actionItemsTemplateDetails: "actionItemsTemplateDetails",
    editActionItemsDialog: "editActionItemsDialog",
    leavingPage: "leavingPage",
    unsavedChanges: "unsavedChanges",
  };

  constructor() {
    this.templateDetailsStore = new BehaviorSubject(this._initialStoreData);
    this.store$ = this.templateDetailsStore.asObservable();
  }

  public get store() {
    return this.templateDetailsStore.value;
  }

  public get templateDetails() {
    return this.store.templateDetails;
  }

  public get sysText() {
    return this.store.sysText;
  }

  public get templateDetails$(): Observable<ActionItemsTemplateDetails> {
    return this.store$.pipe(pluck('templateDetails'))
  }

  public get templates() {
    return this.templateNames;
  }

  public set templateDetails(templateDetails: ActionItemsTemplateDetails) {
    const store = { ...this.store, templateDetails };
    this.templateDetailsStore.next(store);
  }

  public set sysText(sysText: any) {
    const store = { ...this.store, sysText };
    this.templateDetailsStore.next(store);
  }
 
  public unloadStore() {
    const store: ActionItemsTemplateDetailsStore = {
      templateDetails: null,
      sysText: null
    }
    this.templateDetailsStore.next(store)
  }
}